module.exports = __webpack_public_path__ + "static/img/increment06.abac403.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/increment06.png
// module id = cZSS
// module chunks = 0